import { Button, Box, Typography, Paper, Divider, useTheme } from "@mui/material";
import DataGridMAIQ from "app/components/ReusableUIComponents/HighLevelComponents/DataGridMAIQ";
import DataGridTypes from "types/DataGridTypes";
import { AddUserModal } from "./AddUserModal";
import { useState } from "react";
import UserDetailsModal from "./UserDetailsModal";
import AddIcon from '@mui/icons-material/Add';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ButtonMAIQ from "app/components/ReusableUIComponents/LowLevelComponents/buttons/ButtonMAIQ";

const UsersTab = () => {
  const [isAddUserModal, setIsAddUserModal] = useState(false);
  const [isUserDetailsModalOpen, setIsUserDetailModalOpen] = useState({
    data: {},
    status: false,
  });
  const [refreshKey, setRefreshKey] = useState(0); // Rerender key
  const theme = useTheme();

  const handleAddUserModalOpen = () => {
    setIsAddUserModal(true);
  };

  const handleCellClick = (cell) => {
    if (cell.field === "name") {
      setIsUserDetailModalOpen({
        data: cell.row,
        status: true,
      });
    }
  };

  const handleClose = () => {
    setIsUserDetailModalOpen({
      data: {},
      status: false,
    });
    // setRefreshKey((prevKey) => prevKey + 1); // Refresh the DataGrid
  };

  return (
    <Box 
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        height: "100%",
        padding: { xs: 1, sm: 2 }
      }}
    >
      <Paper 
        elevation={0}
        sx={{ 
          p: 2.5,
          display: "flex",
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: "space-between",
          alignItems: { xs: 'flex-start', sm: 'center' },
          borderRadius: 1.5,
          backgroundColor: 'background.paper',
          boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
          gap: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <PeopleAltIcon 
            sx={{ 
              color: theme.palette.primary.main,
              fontSize: 28 
            }} 
          />
          <Box>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1.1rem',
                color: theme.palette.primary.main
              }}
            >
              User Management
            </Typography>
            <Typography 
              variant="body2" 
              color="text.primary"
              sx={{ fontSize: '0.85rem' }}
            >
              Create and manage system users
            </Typography>
          </Box>
        </Box>
        
        <ButtonMAIQ
          variant="contained"
          color="primary"
          onClick={handleAddUserModalOpen}
          startIcon={<AddIcon />}
        >
          Add New User
        </ButtonMAIQ>
      </Paper>
      
      <Divider sx={{ opacity: 0.5 }} />

      <Box sx={{ flexGrow: 1, minHeight: 300 }}>
        <DataGridMAIQ 
          key={refreshKey} 
          type={DataGridTypes.USERS_DATA()} 
          onCellClick={handleCellClick} 
        />
      </Box>

      <AddUserModal
        open={isAddUserModal}
        onClose={() => {
          setIsAddUserModal(false);
          // setRefreshKey((prevKey) => prevKey + 1); // Refresh the DataGrid
        }}
        setRefreshKey={setRefreshKey}
      />
      <UserDetailsModal 
        open={isUserDetailsModalOpen.status} 
        onClose={handleClose} 
        data={isUserDetailsModalOpen.data} 
        setRefreshKey={setRefreshKey} 
      />
    </Box>
  );
};

export default UsersTab;
